import { Card } from "@/components/ui/Card";
import { useDocumentTitle } from "usehooks-ts";
import CounterManagementTable from "./component/table";

const AllCounters = () => {
  useDocumentTitle("Counter Management");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <CounterManagementTable />
      </Card>
    </div>
  );
};

export default AllCounters;
